import React, { useEffect } from "react";
import usePlanetStore from "@store/usePlanetStore";
import ResourceBar from "@components/ui/menu/ResourceBar";
import "./PlanetView.css";

function PlanetView() {
  const { resources, loadResources, loading, error } = usePlanetStore();

  // Carga inicial de recursos al montar el componente
  useEffect(() => {
    loadResources(1); // ID del jugador (ejemplo)
  }, [loadResources]);

  // Manejo de estados de carga o error
  if (loading) return <p>Cargando recursos...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="planet-view">
      {/* Barra de recursos visible si hay datos */}
      {resources && <ResourceBar resources={resources} />}

      {/* Contenido principal del planeta */}
      <div className="planet-content">
        <h1>Planet View</h1>
        <p>Aquí irá el mapa del planeta...</p>
      </div>
    </div>
  );
}

export default PlanetView;